export default function StatCard({ label, value, sublabel, accent, testId }) {
  return (
    <div
      data-testid={testId}
      className="bg-white rounded-xl border border-sif p-5 card-shadow"
    >
      <div className="text-xs text-sif-muted uppercase tracking-wider font-medium">{label}</div>
      <div className={`mt-2 text-2xl font-bold ${accent || "text-sif-primary"}`}>{value}</div>
      {sublabel && <div className="mt-1 text-xs text-sif-muted">{sublabel}</div>}
    </div>
  );
}
